
/**
 * @file baidu域登录页
 * @author fengfaxia(fengfaxia@baidu.com))
 * Copyright (c) 2018-11-23 Baidu
 */
import React from 'react';
import {envConfig} from '../../common/envConfig';
export default class MobileLogin extends React.Component {
    componentDidMount() {
        this.login();
    }
    login() {
        const {dwzBaiduDomain, dwzDomain} = envConfig();
        let login;
        window.passport.use('login', {
                defaultCss: true
            }, function (magic) {
                login = new magic.passport.login({
                    product: 'dwz',
                    // 移动端没法获取退出时的url，固定跳转到某个链接上
                    u: `${dwzBaiduDomain}/redirect?url=${dwzDomain}`,
                    loginTip: '',
                    autosuggest: true,
                    overseas: 0,
                    bindToLoginFn: () => {
                        location.reload();
                    },
                    staticPage: `${dwzBaiduDomain}/static/v3Jump.html`
                });

                login.on('render', function (rsp) {
                    rsp.returnValue = false;
                });
                login.render('login');
            });
    }
    render() {
        return (
            <div id="login"></div>
        );
    }
}

